import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MapReportMainComponent } from "./map-report-main/map-report-main.component";
import { MapContainerComponent } from "./map-container/map-container.component";
import { SubheaderModule } from "../../subheader/subheader.module";
import { MapReportService} from "./services/map-report-service.service";
import { MapReportToolBarComponent } from "./map-report-tool-bar/map-report-tool-bar.component";
import { SharedModule } from 'src/app/shared/shared.module';
import { SafePipe } from "../pedigreechart/pedigree/safe.pipe";
import { TimeBarComponent } from "./time-bar/time-bar.component";


@NgModule({
  declarations: [
    MapReportMainComponent,
    MapContainerComponent,
    MapReportToolBarComponent,
    TimeBarComponent,
    SafePipe,
  ],
  imports: [
    CommonModule,
    SubheaderModule,
    SharedModule,
  ],
  providers: [MapReportService],
})
export class MapReportModule {}

// translation loader moved to SharedModule
